/**
 * @file ProductThumb.tsx
 * @description Превью фото товара с fallback на фирменную заглушку (phase19.5).
 *
 * Если url отсутствует или изображение не загрузилось (протухший presigned,
 * удалённый файл) — показывает ProductImagePlaceholder. Размер задаётся
 * className контейнера (таблица — 40×40, карточка — aspect-[4/3]).
 */

import { useEffect, useState } from "react";

import { cn } from "@/lib/utils";
import { ProductImagePlaceholder } from "./ProductImagePlaceholder";

interface ProductThumbProps {
  src: string | null;
  alt: string;
  className?: string;
}

export function ProductThumb({ src, alt, className }: ProductThumbProps) {
  const [failed, setFailed] = useState(false);

  // Новый url — сбрасываем состояние ошибки (например, после refresh списка).
  useEffect(() => setFailed(false), [src]);

  if (!src || failed) {
    return <ProductImagePlaceholder className={className} />;
  }
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      onError={() => setFailed(true)}
      className={cn("object-cover", className)}
    />
  );
}
